import { Component, inject } from '@angular/core';
import { AuthLayoutComponent } from "src/app/components/auth-layout/auth-layout.component";
import { jwtDecode } from 'jwt-decode';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/users/user.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AlertService } from 'src/app/services/alert.service';

interface MicrosoftJwtPayload {
  sub: string;
  exp: number;
  iat: number;
}

@Component({
  selector: 'app-microsoft-callback',
  standalone: true,
  imports: [
    AuthLayoutComponent,
    TranslateModule,
    MatProgressSpinner
  ],
  templateUrl: './microsoft-callback.component.html'
})
export class MicrosoftCallbackComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);
  private readonly alertService = inject(AlertService);

  ngOnInit() {
    this.route.fragment.subscribe(fragment => {

      const params = new URLSearchParams(fragment ?? '');

      const accessToken = params.get('accessToken');
      const refreshToken = params.get('refreshToken');
      const error = params.get('error');

      if (!accessToken || !refreshToken) {
        this.router.navigate(['/login']);
        this.alertService.show({
          type: 'error',
          subtitle: 'LOGIN.MICROSOFT_ERROR'
        });
        return;
      }

      if (error) {
        this.router.navigate(['/login']);
        return;
      }

      const payload = jwtDecode<MicrosoftJwtPayload>(accessToken);
      const externalId = payload.sub;

      this.userService.getById(externalId, accessToken).subscribe({
        next: (user) => {
          this.alertService.show({
            type: 'success',
            subtitle: 'LOGIN.SUCCESS'
          });

          this.authService.setStorageMicrosoft(
            accessToken,
            refreshToken,
            user
          );
        },
        error: () => {
          this.alertService.show({
            type: 'error',
            subtitle: 'LOGIN.USER_ERROR'
          });
        }
      });
    });
  }
}
